import axios from '@axios'

const PREFIX = '/empresas'

const PREFIXCERTIFICADO = '/certificados'

export default {

  autorizar(empresaAcesso) {
    return axios.post(`${PREFIX}/acesso`, empresaAcesso)
  },

  getDadosDispensaNotificacaoCertificado(certificadoId) {
    return axios.get(`${PREFIXCERTIFICADO}/${certificadoId}/noticacao/dados`)
  },

  dispensaNotificacao(certificadoId, socioemail) {
    return axios.put(`${PREFIX}/certificados/${certificadoId}/noticacao/dispensar?socioEmail=${socioemail}`)
  },

}
